import { Modal, ModalProps } from '../../../../../../components/modal/modal';
import { useLang } from '../../../../../../hooks/use-lang';
import { useRoleStore } from '../../../../../../store/use-role-store';
import { useQueryParams } from '../../../../../../hooks/use-query-params';
import { Button } from '../../../../../../components/button/button';
import s from './roles-dictionary-unattach-modal.module.css';

export const RolesDictionaryUnattachModal = (props: ModalProps) => {
  const { t, getLocale } = useLang();
  const { roleId, employeeId } = useQueryParams().getQueryParams();
  const { roles, putRole } = useRoleStore();

  const handleUpdateRole = async () => {
    try {
      if (roleId && employeeId) {
        const role = roles?.find((item) => item.id === roleId);
        if (role) {
          const updatedRole = {
            ...role,
            employees: role.employees?.filter((emp) => String(emp.id) !== employeeId),
          };
          await putRole(updatedRole);
          props.onClose?.();
        }
      }
    } catch (error) {
      console.error('Error updating role:', error);
    }
  };

  const deletableRole = roles?.find((item) => item.id === roleId);
  const deletableEmployee = deletableRole?.employees?.find((emp) => String(emp.id) === employeeId);

  const employeeFullname = `${getLocale(deletableEmployee?.name)} ${getLocale(
    deletableEmployee?.surname,
  )}`;
  
  return (
    <Modal {...props} title={t('Удаление роли у сторудника')} className={s.feature}>
      {t('Вы уверены, что хотите удалить роль {{roleName}} у сотрудника {{employeeName}}?', {
        roleName: deletableRole?.name,
        employeeName: employeeFullname,
      })}
      <div className={s.controls}>
        <Button size="lg" variant="secondary" onClick={props.onClose}>
          {t('Отменить')}
        </Button>
        <Button size="lg" onClick={handleUpdateRole}>
          {t('Подтвердить')}
        </Button>
      </div>
    </Modal>
  );
};
